import { Stack } from '@mui/material'
import React, { useState, useEffect }  from 'react'
import { fetchAPI } from '@/utility/NetworkUtils'
import Loading from '@/shared/Loading'
import { renderButton, renderSelectFieldFilterable, renderTextField } from '@/shared/FormUtils'
const DistributionLocations = (props) => {
  const { event, formikProps } = props
  const [ submitting, setSubmitting ] = useState(false)
  const addLocation = () => {
    if(submitting) return
    setSubmitting(true)
    const { values: { distribution_location_name } } = formikProps;
    fetchAPI(`/webapi/events/${event.id}/event_locations`, (json)=> {
      setSubmitting(false)
      if(!json.error) {
        formikProps.setFieldValue("distribution_location_name", "")
        formikProps.setFieldValue("event_locations", [...event.event_locations, json.location])
      }else {
        alert(json.error)
      }
    }, {
      method: "POST",
      body: {
        event_location: {
          name: distribution_location_name,
        }
      }
    })

  }

  const deleteLocation = (id) => {
    const { values: { event_locations } } = formikProps;
    fetchAPI(`/webapi/events/${event.id}/event_locations/${id}`, (json)=> {
      if(!json.errors) {
        formikProps.setFieldValue("event_locations", event_locations.filter(x => x.id !== id))
      }else {
        alert(json.error)
      }
    }, {
      method: "DELETE"
    })
  }

  const renderLocations = () => {
    const { event_locations } = formikProps.values;
    console.log({
      
    })
    return (event_locations||[]).map((location) => 
      (
        <div className="flex border-b-1 border-[#e6e6e6] pb-4" key={`location_${location.id}`} style={{borderBottom: "1px solid #e6e6e6"}}>
          <div className="w-full font-bold">
            {location.name}
          </div>
          <div className="flex align-middle px-8 items-center">
            <a href="javascript:void(0)" className="text-blue-600" onClick={(e) => {
              e.preventDefault()
              deleteLocation(location.id)
            }}>
              Remove
            </a>
          </div>
        </div>
      )
    );
  }

  return (
    <Stack direction="column" spacing={2}>
      <div>
        Distributions locations help designate a specific location for delivery.
        <br/>
        (i.e. Staff Office, Hotel Loading Dock, etc.) 
      </div>
      <div className="flex">
        {renderTextField( "Distribution Location", "distribution_location_name", {
          required: true
        })}
        <div className="pl-2 pt-[1.4rem]">
        {renderButton("Add Location", addLocation, {color:"green"})}
        </div>
      </div>
      {renderLocations()}
    </Stack>
  )

}

export default DistributionLocations
